module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user-list"
  }, [_c('div', [_c('div', {
    staticClass: "user-header"
  }, [_c('h1', {
    staticClass: "user-header-title"
  }, [_vm._v(_vm._s(_vm.$t("userList.title")))])]), _vm._v(" "), _c('Loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), (_vm.userList.length) ? _c('div', {
    staticClass: "row d-flex align-items-center mb-5"
  }, [_c('div', {
    staticClass: "col d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.search),
      expression: "search",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "rem3rch-input-text",
    attrs: {
      "type": "text",
      "id": "searchBySearch"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ml-5"
  }, [_c('label', {
    staticClass: "label-checkbox pointer m-0 d-flex align-items-center",
    attrs: {
      "for": "checkboxUsers"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked.checkedUsers),
      expression: "checked.checkedUsers"
    }],
    staticClass: "d-none",
    attrs: {
      "type": "checkbox",
      "id": "checkboxUsers"
    },
    domProps: {
      "checked": Array.isArray(_vm.checked.checkedUsers) ? _vm._i(_vm.checked.checkedUsers, null) > -1 : (_vm.checked.checkedUsers)
    },
    on: {
      "change": _vm.optionsChecked,
      "__c": function($event) {
        var $$a = _vm.checked.checkedUsers,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checked.checkedUsers = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.checked.checkedUsers = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checked.checkedUsers = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checked.checkedUsers),
      expression: "checked.checkedUsers"
    }],
    staticClass: "rem3rch-checkbox rem3rch-checkbox"
  }, [_c('i', {
    staticClass: "fa fa-check"
  })]), _vm._v(" "), (!_vm.checked.checkedUsers) ? _c('span', {
    staticClass: "rem3rch-checkbox rem3rch-checkbox"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "label-title"
  }, [_vm._v(_vm._s(_vm.$trad.userList.viewActiveOnly))])])]), _vm._v(" "), (_vm.hasAccessSuperAdmin()) ? _c('div', {
    staticClass: "ml-5"
  }, [_c('label', {
    staticClass: "label-checkbox pointer m-0 d-flex align-items-center",
    attrs: {
      "for": "checkboxBrands"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked.checkedBrands),
      expression: "checked.checkedBrands"
    }],
    staticClass: "d-none",
    attrs: {
      "type": "checkbox",
      "id": "checkboxBrands"
    },
    domProps: {
      "checked": Array.isArray(_vm.checked.checkedBrands) ? _vm._i(_vm.checked.checkedBrands, null) > -1 : (_vm.checked.checkedBrands)
    },
    on: {
      "change": _vm.optionsChecked,
      "__c": function($event) {
        var $$a = _vm.checked.checkedBrands,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checked.checkedBrands = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.checked.checkedBrands = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checked.checkedBrands = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checked.checkedBrands),
      expression: "checked.checkedBrands"
    }],
    staticClass: "rem3rch-checkbox rem3rch-checkbox"
  }, [_c('i', {
    staticClass: "fa fa-check"
  })]), _vm._v(" "), (!_vm.checked.checkedBrands) ? _c('span', {
    staticClass: "rem3rch-checkbox rem3rch-checkbox"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "label-title"
  }, [_vm._v(_vm._s(_vm.$trad.userList.activateAllBrands))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-auto"
  }, [_c('div', {
    staticClass: "user-header-adduser"
  }, [(_vm.canAddUser()) ? _c('button', {
    staticClass: "btn btn-adduser",
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: "/users/create"
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-xs"
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(_vm.$t("actions.addUser")))])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "user-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.orderBy('id')
      }
    }
  }, [_c('span', [_vm._v("ID")])]), _vm._v(" "), _c('th', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.orderBy('firstname')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$trad.createUser.labelFirstName))])]), _vm._v(" "), _c('th', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.orderBy('lastname')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$trad.createUser.labelLastName))])]), _vm._v(" "), _c('th', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.orderBy('email')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$trad.userList.email))])]), _vm._v(" "), (_vm.hasAccessSuperAdmin()) ? _c('th', [_c('span', [_vm._v(_vm._s(_vm.$trad.userList.brand))])]) : _vm._e(), _vm._v(" "), (_vm.hasAccessSuperAdmin()) ? _c('th', [_c('span', [_vm._v(_vm._s(_vm.$trad.userList.remerchAccess))])]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.orderBy('lastConnection')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$trad.userList.lastConnection.toLocaleString()))])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('th', [_c('span', [_vm._v(_vm._s(_vm.$trad.common.edit))])]), _vm._v(" "), (_vm.hasAccessSuperAdmin()) ? _c('th', [_c('span', [_vm._v(_vm._s(_vm.$trad.common.delete))])]) : _vm._e(), _vm._v(" "), _c('th', [_c('span', [_vm._v(_vm._s(_vm.$trad.common.history))])])])]), _vm._v(" "), _c('tbody', [(!_vm.userListBySearch.length) ? _c('tr', {
    staticClass: "notfound"
  }, [_c('td', {
    attrs: {
      "colspan": _vm.hasAccessSuperAdmin() ? 10 : 9
    }
  }, [_vm._v(_vm._s(_vm.$trad.userrole.notfound))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.userListBySearch), function(user, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "id"
    }, [_c('span', [_vm._v(_vm._s(user.id))])]), _vm._v(" "), _c('td', {
      staticClass: "firstname"
    }, [_c('span', [_vm._v(_vm._s(user.firstname))])]), _vm._v(" "), _c('td', {
      staticClass: "lastname"
    }, [_c('span', [_vm._v(_vm._s(user.lastname))])]), _vm._v(" "), _c('td', {
      staticClass: "email"
    }, [_c('span', [_vm._v(_vm._s(user.email))])]), _vm._v(" "), (_vm.hasAccessSuperAdmin()) ? _c('td', {
      staticClass: "brands"
    }, _vm._l((user.userBrand), function(userBrand) {
      return (!user.isSuperAdmin) ? _c('span', {
        key: userBrand.id,
        staticClass: "allBrands",
        class: userBrand.brand.name.toLowerCase(),
        style: ('background-color: ' + userBrand.brand.linkColor + ';')
      }, [_c('strong', {
        on: {
          "click": function($event) {
            _vm.openModalDeleteBrand(user, userBrand.brand.id)
          }
        }
      }, [_vm._v("X")]), _vm._v(" " + _vm._s(userBrand.brand.name) + "\n                            ")]) : _vm._e()
    })) : _vm._e(), _vm._v(" "), (_vm.hasAccessSuperAdmin()) ? _c('td', {
      staticClass: "checkbox-elm"
    }, [_c('label', {
      staticClass: "label-checkbox m-0 pointer",
      attrs: {
        "for": 'checkbox' + user.id
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (user.isEnabled),
        expression: "user.isEnabled"
      }],
      staticClass: "d-none",
      attrs: {
        "type": "checkbox",
        "id": 'checkbox' + user.id
      },
      domProps: {
        "checked": Array.isArray(user.isEnabled) ? _vm._i(user.isEnabled, null) > -1 : (user.isEnabled)
      },
      on: {
        "change": function($event) {
          _vm.openModalChangeAccess(user)
        },
        "__c": function($event) {
          var $$a = user.isEnabled,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (user.isEnabled = $$a.concat($$v))
            } else {
              $$i > -1 && (user.isEnabled = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            user.isEnabled = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.isEnabled),
        expression: "user.isEnabled"
      }],
      staticClass: "rem3rch-checkbox rem3rch-checkbox"
    }, [_c('i', {
      staticClass: "fa fa-check"
    })]), _vm._v(" "), (!user.isEnabled) ? _c('span', {
      staticClass: "rem3rch-checkbox rem3rch-checkbox"
    }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "lastConnection"
    }, [(user.lastConnectionDate) ? _c('span', [_vm._v(" " + _vm._s(_vm.getDateByFormat(user.lastConnectionDate, "DD/MM/YYYY HH:mm")) + " ")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticClass: "sso"
    }, [(user.isSsoEnabled) ? _c('span', [_c('i', {
      staticClass: "fa fa-check color-grey"
    })]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "edit"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'useraccess',
          params: {
            id: user.id,
            checkedOption: _vm.checked
          }
        }
      }
    }, [_c('img', {
      staticClass: "position-relative",
      attrs: {
        "src": require("../../assets/edit.svg"),
        "alt": "edit"
      }
    })])], 1), _vm._v(" "), (_vm.hasAccessSuperAdmin()) ? _c('td', {
      staticClass: "delete"
    }, [_c('img', {
      staticClass: "position-relative pointer",
      attrs: {
        "src": require("../../assets/delete.svg"),
        "alt": "delete"
      },
      on: {
        "click": function($event) {
          _vm.openModalDeleteBrand(user, _vm.currentBrand.id)
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "history"
    }, [_c('History', {
      attrs: {
        "object": user,
        "object-type": _vm.OBJECT_TYPE.USERS
      }
    })], 1)])
  })], 2)])])], 1), _vm._v(" "), _c('DeleteBrand', {
    attrs: {
      "params": _vm.deleteBrandParams
    },
    on: {
      "loadUsers": _vm.loadUsers
    }
  }), _vm._v(" "), _c('ChangeAccess', {
    attrs: {
      "params": _vm.updateAccessParams
    },
    on: {
      "loadUsers": _vm.loadUsers,
      "resetState": _vm.resetState
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "m-0 pointer ml-3",
    attrs: {
      "for": "searchBySearch"
    }
  }, [_c('i', {
    staticClass: "fa fa-search fa-lg color-grey"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('span', [_vm._v("SSO")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7993b37a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/UserList.vue
// module id = 3282
// module chunks = 0